<template>
  <a-modal
  :maskClosable="false"
    title="编辑用户"
    visible
    :confirm-loading="confirmAddLoading"
    @ok="$emit('complete')"
    destroyOnClose
    @cancel="$emit('complete')"
  >
    <ak-inputs v-model="formdata" :options="options" ref="inputs" />
    <div class="m-b-5">状态</div>
    <a-radio-group name="radioGroup" v-model="status" disabled>
      <a-radio value="enabled">
        启用
      </a-radio>
      <a-radio value="disabled">
        禁用
      </a-radio>
    </a-radio-group>
  </a-modal>
</template>
<script>
import { notEmpty, isPhone } from '../../utils/validator.js'
export default {
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
  data () {
    return {
      defaultPass: 'zhlc123',
      confirmAddLoading: false,
      formdata: {
        ...this.record
      },
      status: this.record.status,
      options: [
        {
          name: 'nickName',
          note: '姓名',
          type: 'String',
          disabled: true,
          validators: [notEmpty()]
        },
        {
          name: 'phone',
          note: '手机号',
          type: 'String',
          disabled: true,
          validators: [notEmpty(), isPhone()]
        },
        {
          name: 'username',
          note: '账号',
          type: 'String',
          disabled: true,
          validators: [notEmpty()]
        }
      ]
    }
  },
  methods: {
  }
}
</script>
<style></style>
